export const environment = {
  production: false,
  // API_URL: "http://127.0.0.1:8050",
  API_URL: "https://apipracticegwdev.healent.com",
  API_DOMAIN_LEGACY: "dev.healent.com",
  API_AUTH_URL: "https://apipracticegwdev.healent.com",
  ECS_URL: "https://api-dev.healent.com",
  NAVIGATOR_API_URL: "https://api-dev.healent.com",
  environment: "development",
  domain: "healent.com",
  SLUG: "cps",
  PUBLIC_KEY: "-----BEGIN PUBLIC KEY-----\n" +
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyVOiyrERRZ6cbpisQ6La\n" +
    "0mGKZyU27dCWXWyQBqNAZevSneS3RDiAR+DH/K+OEJemg3+CetotvRgVUFACuEei\n" +
    "Mq7bXawn4NPqhZS+4f5+ZDWdOzb3k9A5IeVWxAKP9MGsZXBP9SXeTJgPxGcCFwfh\n" +
    "FdtJvKe3O+Ka/RlKYIMzI2u/euONppTrEXaIyONScefz1OYvLnyMcTWRPeLqNTN+\n" +
    "lEnw5vJ0vpasQoKPNrW4xWzV0yuOzAZB5Wgx0lGmVdu0bdzAk2vpWomBH/zomxWQ\n" +
    "PGv+BjlCxFjEnZU72tdOiUtmwy9tpAB5PAqIhvFQfrOLmgoam6mSOms1buYS/FW1\n" +
    "hwIDAQAB\n" +
    "-----END PUBLIC KEY-----",
  PUBLIC_KEY_cps: "-----BEGIN PUBLIC KEY-----\n" +
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyVOiyrERRZ6cbpisQ6La\n" +
    "0mGKZyU27dCWXWyQBqNAZevSneS3RDiAR+DH/K+OEJemg3+CetotvRgVUFACuEei\n" +
    "Mq7bXawn4NPqhZS+4f5+ZDWdOzb3k9A5IeVWxAKP9MGsZXBP9SXeTJgPxGcCFwfh\n" +
    "FdtJvKe3O+Ka/RlKYIMzI2u/euONppTrEXaIyONScefz1OYvLnyMcTWRPeLqNTN+\n" +
    "lEnw5vJ0vpasQoKPNrW4xWzV0yuOzAZB5Wgx0lGmVdu0bdzAk2vpWomBH/zomxWQ\n" +
    "PGv+BjlCxFjEnZU72tdOiUtmwy9tpAB5PAqIhvFQfrOLmgoam6mSOms1buYS/FW1\n" +
    "hwIDAQAB\n" +
    "-----END PUBLIC KEY-----"
};
